import PopupAppendMenuProvider from './PopupAppendMenuProvider';
import PopupCreateMenuProvider from './PopupCreateMenuProvider';
import PopupReplaceMenuProvider from './PopupReplaceMenuProvider';

export default {
    __init__: [
        'fismPopupAppendMenuProvider',
        'fismPopupCreateMenuProvider',
        'fismPopupReplaceMenuProvider',
    ],
    fismPopupAppendMenuProvider: ['type', PopupAppendMenuProvider],
    fismPopupCreateMenuProvider: ['type', PopupCreateMenuProvider],
    fismPopupReplaceMenuProvider: ['type', PopupReplaceMenuProvider],
};
